export default {
    update: "Keep me updated",
    "update-short": "Keep updated",
    thanks: "Thanks!",
    email: "We'll be in touch soon by emailing you at {email}",
    more: "There's so much more to come",
    growth: "Add your email below and we'll keep you updated as {organisation} grows.",
    data: "We'll never share your data without your permission. You can unsubscribe at any time.",
};